import styled from "vue-styled-components";
import { getNodeAccent } from "../../../utils/subsidioCalculoFlowConverter";

const accentProp = { accent: String };

export const FlowCanvas = styled("div")`
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 420px;
  background-color: #f5f7fa;
  background-image: radial-gradient(circle, #d0d7de 1px, transparent 1px);
  background-size: 20px 20px;
  overflow: hidden;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
`;

export const FlowTransformLayer = styled("div")`
  position: absolute;
  top: 0;
  left: 0;
  transform-origin: 0 0;
  width: 100%;
  height: 100%;
  touch-action: none;
`;

export const FlowEdgesSvg = styled("svg")`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: visible;
  pointer-events: none;
`;

export const FlowNodeShell = styled("div", accentProp)`
  position: absolute;
  z-index: 1;
  min-width: 180px;
  background: #fff;
  border-radius: 8px;
  border: 2px solid ${(p) => p.accent || "#bdbdbd"};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  font-size: 13px;
  user-select: none;
  transition: box-shadow 0.15s ease;

  &:hover {
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);
  }

  &.is-selected {
    box-shadow: 0 0 0 3px ${(p) => (p.accent || "#bdbdbd")}33;
  }
`;

export const FlowNodeHeader = styled("div", accentProp)`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  background: ${(p) => p.accent || "#757575"};
  color: #fff;
  border-radius: 6px 6px 0 0;
  font-weight: 600;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
`;

export const FlowNodeBody = styled("div")`
  padding: 10px;
`;

export const FlowHandle = styled("div", { active: Boolean })`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
  border: 2px solid ${(p) => (p.active ? "#1976d2" : "#90a4ae")};
  cursor: crosshair;
  transition: transform 0.1s ease, border-color 0.1s ease;

  &:hover {
    transform: scale(1.2);
    border-color: #1976d2;
  }
`;

export const FlowSidebar = styled("aside")`
  width: 220px;
  flex-shrink: 0;
  border-right: 1px solid rgba(0, 0, 0, 0.08);
  background: #fff;
  padding: 12px;
  overflow-y: auto;
`;

export const FlowSidebarTitle = styled("div")`
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: rgba(0, 0, 0, 0.54);
  margin-bottom: 10px;
`;

export const FlowSidebarItem = styled("button", accentProp)`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 10px;
  margin-bottom: 6px;
  border: 1px solid ${(p) => p.accent || "#ccc"};
  border-left-width: 4px;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  font-size: 12px;
  text-align: left;
  color: rgba(0, 0, 0, 0.87);
  transition: background 0.12s ease;

  &:hover {
    background: ${(p) => (p.accent || "#ccc")}14;
  }
`;

export const FlowContextMenu = styled("div")`
  position: fixed;
  z-index: 9999;
  min-width: 180px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.18);
  padding: 4px 0;
  border: 1px solid rgba(0, 0, 0, 0.08);
`;

export const FlowContextMenuItem = styled("button", accentProp)`
  display: block;
  width: 100%;
  padding: 8px 14px;
  border: none;
  background: transparent;
  text-align: left;
  font-size: 13px;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.87);

  &:hover {
    background: ${(p) => (p.accent ? `${p.accent}18` : "rgba(0,0,0,0.04)")};
  }
`;

export function accentForNodeType(type) {
  return getNodeAccent(type);
}
